<template>
  <div class="no-select d-flex flex-column">
    <div class="title-item">Machine information</div>
    <div v-if="targetImage" class="d-flex justify-content-between">
      <div class="d-flex flex-column font-size-8 ml-3">
        <div>
          <i class="el-icon-cpu mr-2"></i>
          <span>
            <span>ID:&nbsp;&nbsp;&nbsp;</span>
            <span style="color: #ab47bc">{{ targetImage.id }}</span>
          </span>
        </div>
        <div class="mt-1">
          <i class="el-icon-postcard mr-2"></i>
          <span>Name:&nbsp;&nbsp;&nbsp;</span>
          <span style="color: #ab47bc">{{ targetImage.name }}</span>
        </div>
        <div class="mt-1">
          <i class="el-icon-postcard mr-2"></i>
          <span
            >Package:&nbsp;&nbsp;&nbsp;
            <span style="color: #42a5f5">{{ targetImage.packageName }}</span>
          </span>
        </div>
        <div class="mt-1">
          <i class="el-icon-postcard mr-2"></i>
          <span>Size:&nbsp;&nbsp;&nbsp;</span>
          <span style="color: #42a5f5">{{
            targetImage.vhdxLength | formatSize
          }}</span>
        </div>
        <div class="mt-1">
          <i class="el-icon-money mr-2"></i>
          <span>Price:&nbsp;&nbsp;&nbsp;</span>
          <span>{{ targetImage.priceHour }}</span>
          <i class="el-icon-coin ml-1 mr-1"></i>
          <span style="color: #9e9e9e">/ Machine / Hour</span>
        </div>
        <div v-if="!targetImage.fixedRental">
          <div
            class="mt-1"
            v-if="
              targetImage.startTime !== undefined &&
              targetImage.startTime !== null &&
              targetImage.canShutdown
            "
          >
            <i class="el-icon-date mr-2"></i>
            <span>Start time:&nbsp;&nbsp;&nbsp;</span>
            <span style="color: #9e9e9e">{{
              targetImage.startTime | pretyDateUtcToLocal
            }}</span>
          </div>
        </div>
        <div v-else>
          <div class="mt-1">
            <i class="el-icon-time mr-2"></i>
            <span>Time remaining:&nbsp;&nbsp;&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                targetImage.continueRunning
                  ? 'Keep machine running after expired'
                  : 'Shutdown machine after expired'
              "
              placement="top"
            >
              <i
                class="mr-2"
                style="cursor: pointer; margin-right: 0.95rem"
                :style="`color: ${
                  targetImage.continueRunning ? 'forestgreen' : 'red'
                };`"
                :class="`${
                  targetImage.continueRunning
                    ? 'el-icon-monitor'
                    : 'el-icon-switch-button'
                }`"
              ></i>
            </el-tooltip>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="`Manual renewal`"
              placement="top"
            >
              <i
                class="el-icon-date mr-2"
                style="
                  color: forestgreen;
                  margin-right: 0.95rem;
                  cursor: pointer;
                  filter: grayscale(100%);
                "
              ></i>
            </el-tooltip> -->
            <span
              :title="`${
                targetImage.continueRunning
                  ? 'Continue running after expired'
                  : 'Shutdown after expired'
              }`"
              :style="`color: ${
                targetImage.fixedRentalTimeRemaining === 'Expired !'
                  ? 'red'
                  : '#1976D2'
              }; font-weight: 500;`"
              >{{ targetImage.fixedRentalTimeRemaining }}</span
            >
          </div>
          <div class="mt-1">
            <i class="el-icon-date mr-2"></i>
            <span>Start date:&nbsp;&nbsp;&nbsp;</span>
            <span style="color: #e65100; font-weight: 500">{{
              targetImage.startDate | pretyDateUtcToLocal
            }}</span>
          </div>
          <div class="mt-1">
            <i class="el-icon-date mr-2"></i>
            <span>End date:&nbsp;&nbsp;&nbsp;</span>
            <span style="color: #e65100; font-weight: 500">{{
              targetImage.endDate | pretyDateUtcToLocal
            }}</span>
          </div>
        </div>
      </div>
      <div>
        <Lable style="cursor: auto" :element="targetImage" />
      </div>
    </div>
  </div>
</template>

<script>
import Lable from "@/views/component/RentalService/Lable";
import moment from 'moment';
import EventBus from "@/event/EventBus";
import { POPUP_ID } from "@/constant/baseConstant";
const debounce = require('lodash.debounce');
export default {
  components: {
    Lable,
  },  
  props: {
    targetImage: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      debounceRefreshInfo: null, 
      intervalRefresh: null,     
    }
  },
  mounted() {
    if(this.targetImage.fixedRental){
      this.calcRemainTime();
      this.intervalRefresh = setInterval(() => {
        this.calcRemainTime();
      }, 30000);

      this.debounceRefreshInfo = debounce((data) => {
        if(data !== undefined && typeof data === 'string' && data === POPUP_ID.FIXED_RENTAL_RENEWAL_MACHINE){
          console.log("closePopup", data);
          if(this.intervalRefresh !== undefined && this.intervalRefresh !== null){
            clearInterval(this.intervalRefresh);
          }
          this.debounceRefreshInfo = null;
          this.intervalRefresh = null;
        }
      }, 500);
      EventBus.$once("closePopup", (data) => {
        if(typeof this.debounceRefreshInfo === 'function') this.debounceRefreshInfo(data);
      });
    }
    else{
      if(this.intervalRefresh !== undefined && this.intervalRefresh !== null){
        clearInterval(this.intervalRefresh);
      }
      this.debounceRefreshInfo = null;
      this.intervalRefresh = null;
    }
  },
  methods: {
    calcRemainTime(){
      let remainDurations = moment.duration(moment.utc(this.targetImage.endDate).diff(moment.utc()));
      let remainDurationsInHours = remainDurations.asHours();
      let remainDurationsFormated = "";
      if(remainDurationsInHours < 24) remainDurationsFormated = moment.utc(remainDurations.asMilliseconds()).format("H[h] m[m]");
      else remainDurationsFormated = moment.utc(remainDurations.asMilliseconds()).format("D[d] H[h] m[m]");
      this.targetImage.fixedRentalTimeRemaining = remainDurationsFormated;
      //console.log("remainDurations", remainDurationsFormated);
    }
  }
};
</script>